module.exports = __webpack_public_path__ + "img/Image9.3d314ea7.png";